import { CleverResearch } from "./CleverResearch";

export default CleverResearch;
